import { RunParameter } from "../../../../api";
import {  Parameters } from "../Parameters";
import { CaseRunCalculateModel, CaseRunClient, CaseRunCreateModel, CaseRunCreateModelBase, LabClient, MaxLrCaseRunCreateModelBase, ParameterTypes, RunParameterModel } from "@app/api2/api";
import { ICreateRenderer } from "../CaseRunCreate";
import { InformactionMaxLr, MaxLrFormType } from "../InformationMaxLr";
import React from "react";
import { ReviewMaxLr } from "../ReviewMaxLr";
import { Form, FormField } from "@/components/bp/bp-ui";
import { Field } from "formik";
import { MarkerSpecificSettingsEditor } from "../MarkerSpecificSettingsEditor";
import { RareAllelesFreqSelect } from "@common/RareAllelesFreqSelect";
import { MaxLrCaseRuns } from "../Details/Results/MaxLR/MaxLrCaseRuns";
import { Constants } from "../Constants";
import { IParameterRenderer, IParamView, ParameterOwnerModel, RenderParamLabSettingsProps } from "../ParameterRendererAbstracts";

export class MaxLrHandler implements IParameterRenderer, ICreateRenderer<CaseRunCreateModel, any> {
    caseRunClient = new CaseRunClient();

    save(props: { labId: number, caseId: number, model: CaseRunCreateModel }) {
        return new CaseRunClient().createMaxlr(props.labId, props.caseId, props.model)
    }

    createBlankModel(props: { labId: number, caseId: number, runType: string, evidenceId?: number, ednaTestId?: number }): Promise<MaxLrCaseRunCreateModelBase> {
        return this.caseRunClient.new(props.labId, props.caseId, props.runType, props.evidenceId ?? null, props.ednaTestId ?? null) as Promise<MaxLrCaseRunCreateModelBase>
    }

    labClient = new LabClient();

    renderReview(model: CaseRunCreateModelBase, onComplete: (values: any) => void, router: any) {
        return <ReviewMaxLr model={model as CaseRunCreateModel} onComplete={onComplete} router={router} />
    }

    renderInformation(model: CaseRunCreateModelBase, onComplete: (values: any) => void, router: any, rangeOfContributors: boolean) {
        return <InformactionMaxLr model={model as CaseRunCreateModel} onComplete={onComplete} router={router} rangeOfContributors={rangeOfContributors} />
    }

    runType: string = "maxlr";

    canHandle(runType: string): boolean {
        return runType == this.runType;
    }

    applyInformationValuesToModel = (model: MaxLrCaseRunCreateModelBase, values: MaxLrFormType) => {
        // model = fillWithValues(model, values, true)

        model.description = values.description;
        model.numberOfContributors = values.numberOfContributors;
        model.hpNumberOfContributors = values.hpNumberOfContributors;
        model.hdNumberOfContributors = values.hdNumberOfContributors;
        model.hdUnknowns = values.hdUnknowns as any;
        model.hpUnknowns = values.hpUnknowns as any;
        model.populationId = values.populationId;
        model.hd = values.hd;
        model.hp = values.hp;
        model.evidence = values.evidence;
        // model.rangeOfContributorsMin= val;
        // model.rangeOfContributorsMax= number = 2;
        model.hdKnownRelName = values.hdKnownRelName;
        model.hdKnownRelSampleId = values.hdKnownRelSampleId;
        model.aic = false;
        model.sampleSystems = values.sampleSystems
        model.evidenceSystems = values.evidenceSystems
        model.hasSelectedSystems = values.hasSelectedSystems

        let hpUnknowns = model.parameters.find(x => x.parameter == "hpUnknowns");
        if (hpUnknowns != null)
            hpUnknowns.value = model.hpUnknowns.toString();

        let hdUnknowns = model.parameters.find(x => x.parameter == "hdUnknowns");
        if (hdUnknowns != null)
            hdUnknowns.value = model.hdUnknowns.toString();

        let useResttol = model.parameters.find(x => x.parameter == "useResttol");
        if (useResttol != null) {
            let mustUseResttol = parseInt(model.hpUnknowns.toString()) >= Constants.maxUnknowns || parseInt(model.hdUnknowns.toString()) >= Constants.maxUnknowns;

            useResttol.value = mustUseResttol ? '1' : useResttol.value;
            useResttol.userEditable = mustUseResttol ? false : true;
        }

        let allowVariableNoC = model.parameters.find(x => x.parameter == "allowVariableNoC");

        if (allowVariableNoC != null)
            allowVariableNoC.value = values.allowVariableNoC ? "1" : "0";


        return model;
    };

    propsComplete = (model: CaseRunCreateModelBase): void => {
        model.parameters = model.parameters.sort((a, b) => a.order < b.order ? -1 : 1)

        let useBwStut = model.parameters.find(x => x.parameter == "useStutter");
        let useFwStut = model.parameters.find(x => x.parameter == "useFwStutter");

        if (useBwStut != null && useFwStut != null) {
            if (useBwStut.value == "0")
                useFwStut.value = "0";

        }


    };

    // onParameterValueChange = (p: RunParameterModel, newValue: any, parameters: Parameters) => {
    //     // if (p.parameter == "useStutter" && newValue == false) {
    //     //     // if (parameters.form?.current)
    //     //         parameters?.form?.current?.setFieldValue("useFwStutter", "0");
    //     // }
    // };


    renderParameterEditor(model: CaseRunCreateModelBase | CaseRunCalculateModel, p: RunParameter, values, onChange, errors, setFieldValue, parameters: Parameters): JSX.Element {
        return p.parameter == "detectionThreshold" ? (<FormField error={!!errors[p.parameter]}>
            <Field name={p.parameter}
                disabled={false} onChange={async (e, v) => { onChange(p, e.target.value); await this.calcDelta(model.labId, e.target.value, parameters); }} />
        </FormField>) : p.parameter == "detectionThresholds" ? (
            <MarkerSpecificSettingsEditor
                readOnly={false}
                onChange={e => {
                    onChange(p, e)
                }}
                onMarkerValueChange={async (marker, value) => { await this.calcDeltaForMarker(model.labId, value, parameters, marker); }}
                // onMarkersValueChange={async (markers, value) => { await this.calcDeltaForDye(model.labId, value, parameters, markers); }}
                evidenceId={(model as MaxLrCaseRunCreateModelBase).evidence.find(x => x.selected)?.id}
                caseId={model.efmCaseId}
                name={p.parameter}
                labId={model.labId}
                value={values[p.parameter]}
                defaultValue={values.detectionThreshold} />
        ) : p.parameter == "dropInProbabilities" ? (
            <MarkerSpecificSettingsEditor
                readOnly={false}
                onChange={e => { onChange(p, e) }}
                evidenceId={(model as MaxLrCaseRunCreateModelBase).evidence.find(x => x.selected)?.id}
                caseId={model.efmCaseId}
                name={p.parameter}
                labId={model.labId}
                value={values[p.parameter]}
                defaultValue={values.dropInProbability} />
        ) : p.parameter == "dropInHyperParams" ? (<MarkerSpecificSettingsEditor
            readOnly={false}
            onChange={e => { onChange(p, e) }}
            evidenceId={(model as MaxLrCaseRunCreateModelBase).evidence.find(x => x.selected)?.id}
            caseId={model.efmCaseId}
            name={p.parameter}
            labId={model.labId}
            value={values[p.parameter]}
            defaultValue={values.dropInHyperParam} />) : (
            <RareAllelesFreqSelect name={p.parameter} value={values[p.parameter]} onChange={(ev, val) => { onChange(p, val) }} />
        )
    }

    async calcDelta(labId: number, value: any, parameters: Parameters) {
        let res = await this.labClient.calculateDropIn(labId, value);

        await parameters.form.current.setFieldValue("dropInHyperParam", res.lambda);
        await parameters.form.current.setFieldValue("dropInProbability", res.dropInProbability);
    }

    async calcDeltaForMarker(labId: number, value: any, parameters: Parameters, marker: string) {
        let res = await this.labClient.calculateDropIn(labId, value);

        var dropInProps = JSON.parse(parameters.form.current.values.dropInProbabilities)
        var dropInHyps = JSON.parse(parameters.form.current.values.dropInHyperParams)

        dropInProps[marker] = res.dropInProbability
        dropInHyps[marker] = res.lambda

        await parameters.form.current.setFieldValue("dropInHyperParams", JSON.stringify(dropInHyps));
        await parameters.form.current.setFieldValue("dropInProbabilities", JSON.stringify(dropInProps));
    }


    canRenderParameter(parameterName: string): boolean {
        return parameterName == "detectionThreshold"
            || parameterName == "detectionThresholds"
            || parameterName == "dropInHyperParams"
            || parameterName == "dropInProbabilities"
            || parameterName == "rareAlleleFreqType";
    }

    renderParameterView(props: { model: ParameterOwnerModel, p: IParamView }): JSX.Element {
        // console.log(props.model);
        return props.p.parameterType == ParameterTypes.Json ? <span>
            <MarkerSpecificSettingsEditor
                readOnly={true}
                name={props.p.parameter}
                value={props.p.value}
                labId={props.model.labId}
                caseId={props.model.efmCaseId}
                evidenceId={props.model.evidence.find(x => true)?.id} />

        </span> : props.p.parameter == "rareAlleleFreqType" ?
            <RareAllelesFreqSelect readOnly name={props.p.parameter} value={props.p.value as any} /> : <span>{props.p.value}</span>
    }

    renderParameterLabSettings?(p: RenderParamLabSettingsProps): JSX.Element {
        return p.parameter == "rareAlleleFreqType" ? <RareAllelesFreqSelect readOnly={p.readOnly} name={p.parameter} value={p.value as any} onChange={(ev, a) => { p.onChange(a as any) }} /> : null;
    }

    renderRunList?: (props: { canCreateEvidence?: boolean, labId: number, caseId: number }) => React.ReactElement = (props) => {
        return <MaxLrCaseRuns {...props} />
    }

}
